.root {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 8px;
}

.bar {
  flex: none;
  align-self: stretch;
  width: 3px;
  border-radius: 2px;
  background: #f59e0b;
}

.body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.title {
  font-size: 11px;
  font-weight: 700;
  color: #92400e;
}

.desc {
  font-size: 10px;
  line-height: 1.3;
  color: #b45309;
}

.adjust {
  flex: none;
  background: none;
  border: none;
  padding: 0;
  color: #7c3aed;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}
